import { RouteConfig } from 'vue-router'

const router: RouteConfig[] = [
  {
    path: '/changePassword/:id',
    name: 'changePassword',
    component: () => import('pages/Auth/ChangePassword.vue')
  },
  {
    path: '/sent-forgot-password',
    name: 'sentForgotPassword',
    component: () => import('pages/Auth/SentForgotPassword.vue')
  },
]

export default router
